import { inject, Injectable } from '@angular/core';
import { IBatchImport, IBatchImportRow } from '@okcargo-apps/shared-domain';
import {
  FindBatchImportQueryHandler,
  FindBatchImportRowsQuery,
  FindBatchImportRowsQueryHandler,
  SearchBatchImportsQueryHandler,
} from '@okcargo/query-processor';
import { SearchOptionsInput, transformToSearchOptions } from '../query-repository/query.mapper';
import { FindOptions } from '../query-repository/query.model';
import { BaseQueryRepository } from '../query-repository/query.repository';
import {
  transformToIBatchImport,
  transformToIBatchImportList,
  transformToIBatchImportRowList,
} from './batch-import-query.mapper';

@Injectable({
  providedIn: 'root',
})
export class BatchImportQueryService {
  private readonly queryRepository = inject(BaseQueryRepository);

  private readonly findBatchImportQueryHandler: FindBatchImportQueryHandler;
  private readonly searchBatchImportsQueryHandler: SearchBatchImportsQueryHandler;
  private readonly findBatchImportRowsQueryHandler: FindBatchImportRowsQueryHandler;

  constructor() {
    this.findBatchImportQueryHandler = new FindBatchImportQueryHandler(this.queryRepository);
    this.searchBatchImportsQueryHandler = new SearchBatchImportsQueryHandler(this.queryRepository);
    this.findBatchImportRowsQueryHandler = new FindBatchImportRowsQueryHandler(this.queryRepository);
  }

  public async findBatchImport(options: FindOptions): Promise<IBatchImport> {
    const response = await this.findBatchImportQueryHandler.handle(options);
    return transformToIBatchImport(response);
  }

  public async searchBatchImports(options: SearchOptionsInput = {}): Promise<IBatchImport[]> {
    const response = await this.searchBatchImportsQueryHandler.handle(transformToSearchOptions(options));
    return transformToIBatchImportList(response);
  }

  public async findBatchImportRows(query: FindBatchImportRowsQuery): Promise<IBatchImportRow[]> {
    const response = await this.findBatchImportRowsQueryHandler.handle(query);
    return transformToIBatchImportRowList(response);
  }
}
